import React, { useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AddBtn } from '../AddBtn'
import List from '../List'
import { createCostType, deleteCostType, updateCostType } from './actions/ValueBuildUp'
import CostTypeForm from './costTypeForm'
import { Button, Grid, Loader } from 'semantic-ui-react'

const CostType = (props) => {
  const dispatch = useDispatch()
  const [isAdding, setIsAdding] = useState(false)
  const updateAddStatus = useCallback(() => {
    setIsAdding(false)
  }, [isAdding])
  const [isProrating, setIsProrating] = useState(false)
  const updateProrateStatus = useCallback(() => {
    setIsProrating(false)
  }, [isProrating])
  const { translate, isFormDisabled, prorateOnclick ,DropDownReducer} = props
  const costTypeList = useSelector((state) => {
    return state.ValueBuildUpReducer?.shipmentCostType || []
  })
  const AddData = useCallback((updateAddStatus) => {
    dispatch(createCostType({}, updateAddStatus))
  }, [])

  const updateData = useCallback(
    (CostTypeId, payload) => {
      dispatch(updateCostType(CostTypeId, payload))
    },
    [dispatch, updateCostType]
  )

  const deleteData = useCallback(
    (CostTypeId, updateRemovingStatus) => {
      dispatch(deleteCostType(CostTypeId, updateRemovingStatus))
    },
    [dispatch, deleteCostType]
  )

  const renderItem = useCallback(
    (item) => {
      return (
        <CostTypeForm
          key={item.CostTypeId}
          item={item}
          isFormDisabled={isFormDisabled}
          updateData={updateData}
          DropDownReducer={DropDownReducer}
          deleteData={deleteData}
          translate={translate}
        />
      )
    },
    [isFormDisabled, updateData, deleteData, costTypeList?.length, translate]
  )
  return (
    <div className='costType'>
      <List renderItem={renderItem} dataSource={costTypeList} />
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '-5px',
          justifyContent: 'space-between',
        }}
      >
        <Grid.Column
          width='8'
          style={{
            display: 'flex',
            marginLeft: '-1.5em',
            marginTop: '-5px',
          }}
        >
          {!isAdding ? (
            <AddBtn
              disabled={isFormDisabled || isAdding}
              id="addNewCostType"
              onClick={() => {
                setIsAdding(true), AddData(updateAddStatus)
              }}
              text={translate('ADD_NEW_COST_TYPE', { ns: ['default', 'valueBuildUp'] })}
            ></AddBtn>
          ) : (
            <span>
              <Loader active inline size='mini' style={{ marginLeft: '1.2em' }} />
              {translate('ADDING', { ns: ['default', 'lineItem'] })}..
            </span>
          )}
        </Grid.Column>
        <Grid.Column width='8' >
          {!isProrating ? (
              <Button
                basic
                color='blue'
                style={{ marginRight: '-1em',float:'right' }}
                className='btn-toggle'
                onClick={() => {
                  setIsProrating(true), prorateOnclick(updateProrateStatus)
                }}
              >
                {translate('PRORATE', { ns: ['default', 'valueBuildUp'] })}
              </Button>
          ) : (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <Loader
                active
                inline
                size='mini'
                style={{ marginRight: '1.1em', marginTop: '-3px' }}
              />
              {translate('PRORATING', { ns: ['default', 'lineItem'] })}...
            </span>
          )}
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default React.memo(CostType)
